/* istanbul ignore file */
import { createContext, useContext } from 'react';

type SensitiveContextType = {
  sensitiveDataIdSource: string;
  getValueByIdAndSource: (id: string, source: string) => any;
  reloadSensitiveData?: () => void;
};

const SensitiveDataContext = createContext<SensitiveContextType | Dictionary<any>>({});
const SensitiveDataContextProvider = SensitiveDataContext.Provider;

const useSensitiveDataContext = (): SensitiveContextType | Dictionary<any> => {
  const context = useContext(SensitiveDataContext);
  return context || {};
};

export { useSensitiveDataContext, SensitiveDataContextProvider };
